import { render, staticRenderFns } from "./creditEnterDetail.vue?vue&type=template&id=2cbd83a2&scoped=true&"
import script from "./creditEnterDetail.vue?vue&type=script&lang=js&"
export * from "./creditEnterDetail.vue?vue&type=script&lang=js&"
import style0 from "./creditEnterDetail.vue?vue&type=style&index=0&id=2cbd83a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cbd83a2",
  null
  
)

export default component.exports